module.exports = __webpack_public_path__ + "static/media/noRecordFound.7463acc1.png";